import {call, put} from "redux-saga/effects"
import actions from "../../../graphql/actions/school"

export function *getSchools() {
    const schools = yield call(actions.getSchools)
    yield put({type: 'SET_SCHOOLS', payload: schools})
}